// wsClient.js
let ws = null;
let listeners = new Set();
let reconnectTimer = null;
let lastConfig = null;

export function ensureWS(url, token) {
  lastConfig = { url, token };

  if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) {
    return ws;
  }

  ws = new WebSocket(url, token);

  ws.onopen = () => console.log("[ws] singleton connected");
  ws.onmessage = (ev) => listeners.forEach(fn => fn(ev));
  ws.onerror = (e) => console.log("[ws] singleton error", e);

  ws.onclose = () => {
    console.log("[ws] singleton closed, retrying...");
    clearTimeout(reconnectTimer);
    reconnectTimer = setTimeout(() => {
      ws = null;
      if (lastConfig) ensureWS(lastConfig.url, lastConfig.token);
    }, 2000);
  };

  return ws;
}

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
